/**
 * 开发页的 loopback 主机可以是 localhost、127.0.0.1 或 ::1。
 * 会话 Cookie 跟页面主机走，所以同端口的 API/Edge 地址要改成当前页面 origin。
 *
 * Callers: publicEnv getters in src/lib/env.ts
 *
 * Modules:
 * - alignLoopbackBrowserOrigin — 仅替换同协议、同端口的 loopback 主机
 */

// URL.hostname 对 IPv6 有的带方括号、有的不带，两种都算 loopback。
const LOOPBACK_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);

/**
 * 页面和配置都是 loopback 且协议、端口相同则返回页面 origin，否则保持配置。
 * @param configuredOrigin - NEXT_PUBLIC_API_URL 或 TikTok Edge 的 origin
 * @param pageOrigin - window.location.origin；构建或非浏览器环境为 null
 * @returns 浏览器实际应请求的 origin
 */
export function alignLoopbackBrowserOrigin(
  configuredOrigin: string,
  pageOrigin: string | null,
): string {
  if (!pageOrigin) return configuredOrigin;

  let configured: URL;
  let page: URL;
  try {
    configured = new URL(configuredOrigin);
    page = new URL(pageOrigin);
  } catch {
    return configuredOrigin;
  }

  if (configured.protocol !== page.protocol || configured.port !== page.port) {
    return configuredOrigin;
  }
  if (
    !LOOPBACK_HOSTS.has(configured.hostname) ||
    !LOOPBACK_HOSTS.has(page.hostname)
  ) {
    return configuredOrigin;
  }
  return page.origin;
}
